export enum CalculateKinds {
  Calculate = 1,
  Conditional = 2,
  PeriodDate = 3,
  PeriodTime = 4,
  CompareDate = 5,
}
